module.exports = "\n<i-select :id=\"id\" :disabled=\"type\" :multiple=\"shape\" :style='st'>\n  <i-option v-for=\"item in cityList\" :value=\"item.value\" :key='item.value'>{{ item.label }}</i-option>\n</i-select>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/components/select/src/index.vue
// module id = 2323
// module chunks = 38